import { type SupportedCountryCode } from '@zep-us/i18n';

/**
 * 국가별 플랜 문의 링크
 * 각 국가에서 플랜 연장, 멤버 추가 등의 문의를 위한 링크를 정의합니다.
 */
export const PLAN_INQUIRY_LINKS: Partial<Record<SupportedCountryCode, string>> =
  {
    KR: 'https://zep-us.channel.io/workflows/776222', // 한국
    JP: 'https://zep-us.channel.io/workflows/779580', // 일본
    TH: 'https://lin.ee/X46KGYN', // 태국
    ID: 'https://wa.me/6285179812262', // 인도네시아
    MY: 'https://wa.me/6285179812262', // 말레이시아
  };

/**
 * 기타 국가에서 사용할 기본 문의 링크
 */
export const DEFAULT_INQUIRY_LINK =
  'https://zep-us.channel.io/workflows/779571';

/**
 * 사용자의 국가 코드에 따라 적절한 문의 링크를 반환합니다.
 * @param countryCode - 사용자의 국가 코드
 * @returns 해당 국가의 문의 링크 또는 기본 링크
 */
export const getInquiryLinkByCountryCode = (
  countryCode?: SupportedCountryCode | string | null,
): string => {
  if (!countryCode) {
    return DEFAULT_INQUIRY_LINK;
  }

  const normalizedCountryCode =
    countryCode.toUpperCase() as SupportedCountryCode;
  return PLAN_INQUIRY_LINKS[normalizedCountryCode] || DEFAULT_INQUIRY_LINK;
};
